import { fileDownload } from './fileDownload'
import { JSON2CSV } from './JSON2CSV'
import { DownloadCSVType } from './interfaces'

const DownloadCSV = ({
  exclude = '',
  jsonData,
  filename,
  linkname
}: DownloadCSVType) => {
  const handleDownload = () => {
    fileDownload({
      data: JSON2CSV({ jsonData, exclude }),
      filename
    })
  }
  return (
    <button className="link" onClick={handleDownload}>
      {linkname}
    </button>
  )
}

export default DownloadCSV
